// extracted by mini-css-extract-plugin
export default {"root":"BenefitLine_root__I8tQR","dot":"BenefitLine_dot__wWBYK","blue":"BenefitLine_blue__LoH9T","center":"BenefitLine_center__fCuGK"};